{
  "data": [
    {
      "id": 6,
      "name": "Fakulteti i Drejtësisë",
      "university": 1,
      "domain": "",
      "it_email": ""
    },
    {
      "id": 5,
      "name": "Fakulteti i Ekonomisë",
      "university": 1,
      "domain": "",
      "it_email": ""
    },
    {
      "id": 3,
      "name": "Fakulteti i Gjuhëve të Huaja",
      "university": 1,
      "domain": "",
      "it_email": ""
    },
    {
      "id": 1,
      "name": "Fakulteti i Historisë dhe Filologjisë",
      "university": 1,
      "domain": "",
      "it_email": ""
    },
    {
      "id": 4,
      "name": "Fakulteti i Shkencave Sociale",
      "university": 1,
      "domain": "",
      "it_email": ""
    },
    {
      "id": 2,
      "name": "Fakulteti i Shkencave të Natyrës",
      "university": 1,
      "domain": "",
      "it_email": ""
    },
    {
      "id": 32,
      "name": "Fakulteti i Arkitekturës dhe Urbanistikës",
      "university": 7,
      "domain": "",
      "it_email": ""
    },
    {
      "id": 33,
      "name": "Fakulteti i Gjeologjisë dhe i Minierave",
      "university": 7,
      "domain": "fgjm.edu.al",
      "it_email": "emiljan.gjura@fgjm.edu.al"
    },
    {
      "id": 30,
      "name": "Fakulteti i Inxhinierisë Elektrike",
      "university": 7,
      "domain": "",
      "it_email": ""
    },
    {
      "id": 34,
      "name": "Fakulteti i Inxhinierisë Matematike dhe Inxhinierisë Fizike",
      "university": 7,
      "domain": "",
      "it_email": "g.lame@fimif.edu.al"
    },
    {
      "id": 114,
      "name": "Fakulteti i Inxhinierisë Mekanike",
      "university": 7,
      "domain": "fim.edu.al",
      "it_email": "fsulanjaku@fim.edu.al"
    },
    {
      "id": 31,
      "name": "Fakulteti i Inxhinierisë së Ndërtimit",
      "university": 7,
      "domain": "",
      "it_email": ""
    },
    {
      "id": 29,
      "name": "Fakulteti i Teknologjisë së Informacionit",
      "university": 7,
      "domain": "",
      "it_email": ""
    },
    {
      "id": 7,
      "name": "Fakulteti i Mjekësisë",
      "university": 2,
      "domain": "fakultetimjekesise.edu.al",
      "it_email": "anila.gjonaj@fakultetimjekesise.edu.al"
    },
    {
      "id": 8,
      "name": "Fakulteti i Mjekësisë Dentare",
      "university": 2,
      "domain": "umed.edu.al",
      "it_email": "gneci.kruja@umed.edu.al"
    },
    {
      "id": 9,
      "name": "Fakulteti i Shkencave Mjekësore Teknike",
      "university": 2,
      "domain": "umed.adu.al",
      "it_email": "fatjon.elezaj@umed.edu.al"
    },
    {
      "id": 43,
      "name": "Fakulteti i Bioteknologjisë dhe Ushqimit",
      "university": 10,
      "domain": "ubt.edu.al",
      "it_email": "bspaho@ubt.edu.al"
    },
    {
      "id": 42,
      "name": "Fakulteti i Bujqësisë dhe Mjedisit",
      "university": 10,
      "domain": "ubt.edu.al",
      "it_email": "bspaho@ubt.edu.al"
    },
    {
      "id": 41,
      "name": "Fakulteti i Ekonomisë dhe Agrobiznesit",
      "university": 10,
      "domain": "ubt.edu.al",
      "it_email": "bspaho@ubt.edu.al"
    },
    {
      "id": 40,
      "name": "Fakulteti i Mjekësisë Veterinare",
      "university": 10,
      "domain": "ubt.edu.al",
      "it_email": "bspaho@ubt.edu.al"
    },
    {
      "id": 44,
      "name": "Fakulteti i Shkencave Pyjore",
      "university": 10,
      "domain": "ubt.edu.al",
      "it_email": "bspaho@ubt.edu.al"
    },
    {
      "id": 24,
      "name": "Fakulteti i Biznesit",
      "university": 6,
      "domain": "uamd.edu.al",
      "it_email": "arkendballa@uamd.edu.al"
    },
    {
      "id": 25,
      "name": "Fakulteti i Edukimit",
      "university": 6,
      "domain": "uamd.edu.al",
      "it_email": "arkendballa@uamd.edu.al"
    },
    {
      "id": 27,
      "name": "Fakulteti i Shkencave Politike dhe Juridike",
      "university": 6,
      "domain": "uamd.edu.al",
      "it_email": "arkendballa@uamd.edu.al"
    },
    {
      "id": 26,
      "name": "Fakulteti i Studimeve Profesionale",
      "university": 6,
      "domain": "uamd.edu.al",
      "it_email": "arkendballa@uamd.edu.al"
    },
    {
      "id": 28,
      "name": "Fakulteti i Studimeve të Integruara me Praktikën",
      "university": 6,
      "domain": "uamd.edu.al",
      "it_email": "arkendballa@uamd.edu.al"
    },
    {
      "id": 23,
      "name": "Fakulteti i Teknologjisë së Informacionit",
      "university": 6,
      "domain": "uamd.edu.al",
      "it_email": "arkendballa@uamd.edu.al"
    },
    {
      "id": 13,
      "name": "Fakulteti Ekonomik",
      "university": 3,
      "domain": "unishk.edu.al",
      "it_email": "elton.shpuza@unishk.edu.al"
    },
    {
      "id": 15,
      "name": "Fakulteti i Drejtësisë",
      "university": 3,
      "domain": "",
      "it_email": ""
    },
    {
      "id": 14,
      "name": "Fakulteti i Gjuhëve të Huaja",
      "university": 3,
      "domain": "unishk.edu.al",
      "it_email": "gentian.gjyli@unishk.edu.al"
    },
    {
      "id": 10,
      "name": "Fakulteti i Shkencave Shoqërore",
      "university": 3,
      "domain": "unishk.edu.al",
      "it_email": "rovena.mesi@unishk.edu.al"
    },
    {
      "id": 12,
      "name": "Fakulteti i Shkencave të Edukimit",
      "university": 3,
      "domain": "unishk.edu.al",
      "it_email": "virtyt.bushati@unishk.edu.al"
    },
    {
      "id": 11,
      "name": "Fakulteti i Shkencave të Natyrës",
      "university": 3,
      "domain": "unishk.edu.al",
      "it_email": "andi.cungeli@unishk.edu.al"
    },
    {
      "id": 53,
      "name": "Fakulteti Ekonomik",
      "university": 12,
      "domain": "",
      "it_email": ""
    },
    {
      "id": 49,
      "name": "Fakulteti i Shkencave Humane",
      "university": 12,
      "domain": "",
      "it_email": ""
    },
    {
      "id": 51,
      "name": "Fakulteti i Shkencave Mjekësore Teknike",
      "university": 12,
      "domain": "",
      "it_email": ""
    },
    {
      "id": 52,
      "name": "Fakulteti i Shkencave të Edukimit",
      "university": 12,
      "domain": "",
      "it_email": ""
    },
    {
      "id": 50,
      "name": "Fakulteti i Shkencave të Natyrës",
      "university": 12,
      "domain": "",
      "it_email": ""
    },
    {
      "id": 48,
      "name": "Fakulteti i Ekonomisë",
      "university": 11,
      "domain": "",
      "it_email": ""
    },
    {
      "id": 46,
      "name": "Fakulteti i Shëndetit Publik",
      "university": 11,
      "domain": "",
      "it_email": ""
    },
    {
      "id": 47,
      "name": "Fakulteti i Shkencave Humane",
      "university": 11,
      "domain": "",
      "it_email": ""
    },
    {
      "id": 45,
      "name": "Fakulteti i Shkencave Teknike",
      "university": 11,
      "domain": "",
      "it_email": ""
    },
    {
      "id": 22,
      "name": "Fakulteti i Bujqësisë",
      "university": 5,
      "domain": "unkorce.edu.al",
      "it_email": "egace@unkorce.edu.al"
    },
    {
      "id": 21,
      "name": "Fakulteti i Edukimit dhe Filologjisë",
      "university": 5,
      "domain": "unkorce.edu.al",
      "it_email": "dkonini@unkorce.edu.al"
    },
    {
      "id": 20,
      "name": "Fakulteti i Ekonomisë",
      "university": 5,
      "domain": "unkorce.edu.al",
      "it_email": "egace@unkorce.edu.al"
    },
    {
      "id": 19,
      "name": "Fakulteti i Shkencave të Natyrës dhe Humane",
      "university": 5,
      "domain": "unkorce.edu.al",
      "it_email": "etasho@unkorce.edu.al"
    },
    {
      "id": 18,
      "name": "Fakulteti Ekonomik",
      "university": 4,
      "domain": "uogj.edu.al",
      "it_email": "dmiho@uogj.edu.al"
    },
    {
      "id": 17,
      "name": "Fakulteti i Edukimit dhe Shkencave Shoqërore",
      "university": 4,
      "domain": "uogj.edu.al",
      "it_email": "dmiho@uogj.edu.al"
    },
    {
      "id": 16,
      "name": "Fakulteti i Shkencave të Natyrës",
      "university": 4,
      "domain": "uogj.edu.al",
      "it_email": "akllapi@uogj.edu.al"
    },
    {
      "id": 38,
      "name": "Fakulteti i Arteve të Bukura",
      "university": 9,
      "domain": "uart.edu.al",
      "it_email": "erjon.sulaj@uart.edu.al"
    },
    {
      "id": 39,
      "name": "Fakulteti i Artit Skenik",
      "university": 9,
      "domain": "uart.edu.al",
      "it_email": "erjon.sulaj@uart.edu.al"
    },
    {
      "id": 37,
      "name": "Fakulteti i Muzikës",
      "university": 9,
      "domain": "uart.edu.al",
      "it_email": "erjon.sulaj@uart.edu.al"
    },
    {
      "id": 35,
      "name": "Fakulteti i Shkencave të Lëvizjes",
      "university": 8,
      "domain": "ust.edu.al",
      "it_email": "esamimi@ust.edu.al"
    },
    {
      "id": 120,
      "name": "Fakulteti i Shkencave të Rehabilitimit",
      "university": 8,
      "domain": "ust.edu.al",
      "it_email": "esamimi@ust.edu.al"
    },
    {
      "id": 36,
      "name": "Fakulteti i Veprimtarisë Fizike dhe Rekreacionit",
      "university": 8,
      "domain": "ust.edu.al",
      "it_email": "esamimi@ust.edu.al"
    }
  ]
}
